module.exports = __webpack_public_path__ + "static/media/nynfc6.3a12aef4.jpg";